import React, { Component } from 'react';
import SlidingPanels from '../components/SlidingPanels';
import $ from 'jquery';

export default class Feedback extends Component {
    componentDidMount() {
        document.title = `Feedback - C&A Assembly & Installation Solution`;

        this.props.clearSlides();
        $.get('/data/slides/feedback.json').done(function (data) {
            for (let i = 0, len = data.length; i < len; i++) {
                this.props.addSlide(data[ i ]);
            }
        }.bind(this));

        $(window).scrollTo(30, '0.5s');

        var parseFBML = function () {
            window.FB.XFBML.parse();
            window.FB.Event.subscribe('xfbml.render', function () {
                let loader = document.querySelector('.loader');
                if (!!loader) {
                    let parent = loader.parentNode;
                    if (!!parent) {
                        parent.removeChild(loader);
                    }
                }
            });
        };

        window.fbAsyncInit = function () {
            parseFBML();
        };

        if (typeof(window.FB) !== 'undefined') {
            parseFBML();
        }
    }

    render() {
        return (
            <div>
                <SlidingPanels {...this.props }/>
                <div className="container">
                    <div className="row"> 
                        <div className="col-xs-12">
                            <h1>Feedback</h1>
                            <div className="loader"></div>
                            <div className="fb-comments" data-href="http://cna.net.au/" data-numposts="10" data-width="100%" data-order-by="reverse_time"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/Feedback.js